import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { projectStatus } from '../../../constants/project-status';
import { ProjectListItem } from '../../../models/projects/project-list-item.model';
@Component({
    selector: 'app-project-details-card',
    styleUrls: ['./project-details-card.component.scss'],
    templateUrl: './project-details-card.component.html',
})
export class ProjectDetailsCardComponent {
    @Input() project: ProjectListItem;
    @Input() isAdmin = false;
    @Input() isOwner = false;

    constructor(
        private router: Router,
    ) {}
    isEditable() {
        return (this.isOwner || this.isAdmin) && this.isStatusEligibleForEdit();
    }

    isStatusEligibleForEdit(): boolean {
        return this.project.status !== projectStatus.finished;
    }

    public navigateToProject(): void {
        this.router.navigate(['/projects', this.project.id]);
    }
}
